import React__default, { useEffect, useCallback } from 'react';
import { emitUserInteractionEvent, setCookie, getCookie } from './utils.es.js';
import { PolicyModal } from '../PolicyModal.es.js';
import { useQueryPolicyPending } from './useQueryPolicyPending.es.js';

const SNOOZE_COOKIE_PREFIX = "policySnooze";
const SNOOZE_COOKIE_EXP = 60 * 60;
const EVENT_POLICY_INTERACTION_NAME = "policy_pending_check";
const formatSlugForCookie = (slug) => `${SNOOZE_COOKIE_PREFIX}_${slug}`;
const silenceLogger = (slug, reasons) => {
  console.info(`Silencing pending policy \`${slug}\` because ${reasons}.`);
};
const PolicyPendingCheck = (props) => {
  const { policy, acceptPolicy } = useQueryPolicyPending(props.zapierUrl || "");
  useEffect(() => {
    if (policy) {
      emitUserInteractionEvent({
        interaction_name: EVENT_POLICY_INTERACTION_NAME,
        event_action: "in_view",
        option_selected: `${policy.slug} ${policy.content}`
      });
    }
  }, [policy]);
  const onAccept = useCallback(async () => {
    if (!policy) {
      return null;
    }
    emitUserInteractionEvent({
      interaction_name: EVENT_POLICY_INTERACTION_NAME,
      event_action: "click",
      option_selected: `${policy.slug} ${policy.content}`
    });
    try {
      await acceptPolicy();
    } catch (_a) {
      setCookie(formatSlugForCookie(policy.slug), "from_accept_err", SNOOZE_COOKIE_EXP);
    }
  }, [policy]);
  if (!policy) {
    return null;
  }
  if (props.currentPathname === policy.slug) {
    silenceLogger(policy.slug, "pathname");
    return null;
  }
  const hasSnoozeCookie = Boolean(getCookie(formatSlugForCookie(policy.slug)));
  if (hasSnoozeCookie) {
    silenceLogger(policy.slug, "snooze is on");
    return null;
  }
  return React__default.createElement(PolicyModal, { onAccept, renderMarkdown: props.renderMarkdown, title: policy.title, tldr: policy.tldr, url: `https://zapier.com/${policy.slug}` });
};

export { PolicyPendingCheck };
//# sourceMappingURL=PolicyPendingCheck.es.js.map
